export default __webpack_public_path__ + "static/media/talent-header-Dev-IT.2c376925.png";